export const IMAGES = [
  { src: "https://i.ibb.co/S3qtZg9/111.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/S3qtZg9/112.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/fp0FhNK/1731390309406.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/kBTjWCB/1731390309485.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/2cTz27Q/1731390309552.jpg", thumbnail: "" },
];

